import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { OverlayServiceBase, TiimeOverlayConfig } from 'tiime-material';

import { DateInput } from '@helpers/date.helper';

import { ContractReminderOverlayData } from './contract-reminder-overlay-data';
import { ContractReminderOverlayReturnedData } from './contract-reminder-overlay-returned-data';
import { ContractReminderOverlayComponent } from './contract-reminder-overlay.component';

export interface UpdateNextReminderDateData {
  contractId: number;
  nextReminderDate: DateInput;
}

@Injectable({
  providedIn: 'root'
})
export class ContractReminderOverlayService extends OverlayServiceBase<
  ContractReminderOverlayReturnedData,
  ContractReminderOverlayData
> {
  private readonly updateNextReminderDateSubject = new Subject<UpdateNextReminderDateData>();
  // eslint-disable-next-line @typescript-eslint/member-ordering
  readonly updateNextReminderDate$ = this.updateNextReminderDateSubject.asObservable();

  open(data: ContractReminderOverlayData, config: TiimeOverlayConfig | undefined): this {
    this.overlayRef = this.overlayService.open(ContractReminderOverlayComponent, data, {
      disposeOnNavigation: true,
      width: '350px',
      height: 'auto',
      hasBackdrop: true,
      backdropClose: true,
      ...config
    });
    return this;
  }

  close(): void {
    if (this.overlayRef) {
      this.overlayRef.close(null);
    }
  }

  updateNextReminderDate(data: UpdateNextReminderDateData): void {
    this.updateNextReminderDateSubject.next(data);
  }
}
